"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _temp, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp2;

var WeakMap = global.WeakMap || (_temp =
/*#__PURE__*/
function () {
  function _temp() {
    babelHelpers.classCallCheck(this, _temp);
    this._map = [];
  }

  babelHelpers.createClass(_temp, [{
    key: "delete",
    value: function _delete(key) {
      this._map = this._map.filter(function (v) {
        return v.key !== key;
      });
    }
  }, {
    key: "__find",
    value: function __find(key) {
      return this._map.filter(function (v) {
        return v.key === key;
      })[0];
    }
  }, {
    key: "get",
    value: function get(key) {
      var value = this.__find(key);

      if (value) return value.value;
      return void 0;
    }
  }, {
    key: "has",
    value: function has(key) {
      return !!this.__find(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var t = this.__find(key);

      if (t) {
        t.value = value;
      } else {
        t = {
          key: key,
          value: value
        };

        this._map.push(t);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this._map = [];
    }
  }]);
  return _temp;
}(), _temp);
var PromiseRenderer = (_class2 = (_temp2 = _class3 =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PromiseRenderer, _Component);

  function PromiseRenderer() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PromiseRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PromiseRenderer)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "promise", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "pending", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "error", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "success", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = PromiseRenderer._stateFor(_this.promise);
    return _this;
  }

  babelHelpers.createClass(PromiseRenderer, [{
    key: "promiseResolved",
    value: function promiseResolved(value) {
      var st = Object.assign(PromiseRenderer._stateFor(this.promise), {
        resolved: true,
        resolvedSuccess: true,
        resolvedValue: value
      });
      if (this.promise) PromiseRenderer.promises.set(this.promise, st);
      this.setState(st);
    }
  }, {
    key: "promiseRejected",
    value: function promiseRejected(value) {
      var st = Object.assign(PromiseRenderer._stateFor(this.promise), {
        resolved: true,
        resolvedSuccess: false,
        resolvedError: value
      });
      if (this.promise) PromiseRenderer.promises.set(this.promise, st);
      this.setState(st);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.resolved && this.promise) this.promise.then(this.promiseResolved, this.promiseRejected);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.promise != this.promise) {
        this.setState(PromiseRenderer._stateFor(this.promise), function () {
          if (!_this2.state.resolved && _this2.promise) _this2.promise.then(_this2.promiseResolved, _this2.promiseRejected);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.resolved) return this.pending();
      if (this.state.resolvedSuccess) return this.success(this.state.resolvedValue);
      return this.error(this.state.resolvedValue);
    }
  }], [{
    key: "_stateFor",
    value: function _stateFor(promise) {
      var v = this.promises.get(promise);
      if (v) return v;
      v = {
        resolved: false,
        resolvedSuccess: false,
        resolvedValue: null,
        resolvedError: null
      };
      if (promise) this.promises.set(promise, v);
      return v;
    }
  }]);
  return PromiseRenderer;
}(_react.Component), _class3.promises = new WeakMap(), _class3._Pending = new Promise(function () {}), _temp2), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class2.prototype, "promise", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return PromiseResolver._Pending;
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class2.prototype, "pending", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return null;
    };
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class2.prototype, "error", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (error) {
      return null;
    };
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class2.prototype, "success", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (value) {
      return null;
    };
  }
}), babelHelpers.applyDecoratedDescriptor(_class2.prototype, "promiseResolved", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class2.prototype, "promiseResolved"), _class2.prototype), babelHelpers.applyDecoratedDescriptor(_class2.prototype, "promiseRejected", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class2.prototype, "promiseRejected"), _class2.prototype)), _class2);
exports.default = PromiseRenderer;